/**
 * Shared cell styling for wide `CCMSDataTable` tables.
 *
 * `CCMSDataTable` has no scroll wrapper and applies `width` to the `<th>` only, so columns compete for
 * space and content gets crushed. These are the counter-measures — see
 * `_memory/_ui/03-ui-patterns.md` §"Wide tables".
 */

/**
 * Mantine badges ellipsise their label once the cell gets narrow (`.label` is
 * `overflow:hidden;text-overflow:ellipsis` and the root is capped at `max-width:100%`), which turns
 * status/need pills into "ASSIGN…" / "LE…". This lets them size to their content instead.
 */
export const badgeStyles = {
  root: { maxWidth: 'none' },
  label: { overflow: 'visible' as const, textOverflow: 'clip' as const },
};

/** Keep a cell on one line so the column claims the width it actually needs. */
export const noWrap = { whiteSpace: 'nowrap' as const };
